import { Component, OnInit } from '@angular/core';
import { YouTubePlayer } from '@angular/youtube-player';

@Component({
    standalone: true,
    template: '<youtube-player videoId="MRmYYqR80Hk"></youtube-player>',
    selector: 'app-video',
    imports: [YouTubePlayer]
})
export class VideoComponent implements OnInit {
    ngOnInit() {
        const tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);
    }
}
